module.exports = __webpack_public_path__ + "img/new_index_cases22.8e13f2c8.png";